import React, { useEffect, useState } from "react";
import { useAuth } from "../../AuthContext";
import { url } from "../../Config";
import ResultCard from "../Utils/ResultCard";

const Results = () => {
  const { user } = useAuth();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch(`${url}/api/results-history`, {
          headers: { Authorization: `Bearer ${user?.token}` },
        });
        const data = await res.json();
        setResults(Array.isArray(data) ? data : []);
      } catch (err) {
        setResults([]);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [user]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#E6F0FF] to-[#BFD7FF] px-4 sm:px-6 lg:px-12 py-12">
      <h1 className="text-3xl sm:text-4xl font-extrabold mb-12 text-blue-900 text-center tracking-tight">
        Your Test Results
      </h1>

      {loading ? (
        <div className="text-blue-700 text-lg text-center">Loading...</div>
      ) : results.length === 0 ? (
        <div className="text-center py-10">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-1">
            No results yet
          </h3>
          <p className="text-gray-500 text-sm sm:text-base">
            Complete a test to see your results here.
          </p>
        </div>
      ) : (
        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-1
            md:grid-cols-2
            lg:grid-cols-3
            xl:grid-cols-4
            gap-6
          "
        >
         {results.map((r) => (
<div
  key={r._id}
  className="
    w-full
    rounded-2xl
    border border-blue-100/30
    transition-transform
    duration-300
    hover:shadow-2xl
    hover:-translate-y-1
    flex flex-col
    bg-white/80
    max-h-[24rem]      /* mobile default */
    sm:max-h-[28rem]   /* small screens and up */
    md:max-h-[32rem]   /* medium screens and up */
    lg:max-h-[32.8rem]   /* large screens and up */
    xl:max-h-[32.8rem]   /* extra-large screens */
  "
>
    {/* Top Banner */}
    <div className="bg-blue-900 rounded-t-3xl p-4 flex justify-between items-center">
      <div className="text-base sm:text-lg font-semibold text-blue-100">
        {r.testName}
      </div>
      <div className="text-sm sm:text-base font-bold text-blue-200">
        {r.grade || "N/A"}
      </div>
    </div>

    {/* Author */}
    <div className="px-4 sm:px-6 py-2 text-sm sm:text-base text-blue-600">
      By <span className="font-medium">{r.authorId?.username || "Unknown"}</span>
    </div>

    {/* Separator */}
    <div className="h-px bg-blue-200/30 my-2 mx-4 sm:mx-6"></div>
        <div className = " overflow-y-auto custom-scroll"> 
    {/* Result Card */}
    <ResultCard
      score={r.totalScore}
      max={r.totalMaxScore}
      grade={r.grade}
      gradeRules={[]}
      scoresByCategory={r.scoresByCategory}
      modifications={r.modifications || {}}
      endTime={r.createdAt}
      createdAt={r.createdAt}
      compact
    />
    </div>
  </div>
))}
        </div>
      )}
    </div>
  );
};

export default Results;